import styled from "styled-components";
import {
  greyDark,
  primaryHover,
  primary,
  greyBlack,
  black,
  placeholderColor,
  grey,
  sideBarWidth,
  headerHeight,
  secondaryColor,
  projectGridItemWidth,
  projectGridItemHeight,
  lightInactive,
  white,
  accent,
  md,
  primary_00,
  primayColor,
  greyDark_01,
  onHoverDropShadow,
  lightBlackAlpha16,
} from "./variable";
import { Field } from "formik";
import { Rnd } from "react-rnd";

export const StyledStoryWrapper = styled.div`
  height: 100%;
  width: 100%;
  // background: ${secondaryColor};
  // border-radius: 0.5rem 0.5rem 0 0;
`;

export const StyledStoryPageWrapper = styled.div`
  ${(props) => `
    height: 100%;
    width: ${props.artboardSize.widthPercentage}%;
  `}
`;

export const StyledSlideBody = styled.div`
  height: 100%;
  width: 100%;
`;

export const StyledSlideInActive = styled.div`
  background-color: ${black};
  opacity: 0.85;
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  height: 100%;
  width: 100%;
`;

export const StyledDesignCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  cursor: pointer;
  ${(props) => props.cardHeight && `height: ${props.cardHeight};`}
  ${(allowOverflow) => (!allowOverflow ? "overflow: hidden;" : "")};
  height: fit-content;
  border-radius: 8px;

  :hover {
    box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -webkit-box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -moz-box-shadow: 0px 0px 40px ${onHoverDropShadow};
  }

  .thumbnail {
    align-items: center;
    display: flex;
    justify-content: center;
    height: 180px;
    position: relative;
    width: 100%;
    background-color: ${greyDark_01};
    border-radius: 8px 8px 0 0;

    .placeholder {
      width: ${(props) =>
        props.varient === "story"
          ? "108px"
          : props.varient === "cover"
          ? "205px"
          : props.varient === "post"
          ? "151px"
          : props.varient === "ad"
          ? "240px"
          : props.varient === "app_ad"
          ? "45px"
          : props.varient === "header_cover"
          ? "205px"
          : "74px"};

      height: ${(props) =>
        props.varient === "story"
          ? "192px"
          : props.varient === "cover"
          ? "78px"
          : props.varient === "post"
          ? "151px"
          : props.varient === "ad"
          ? "125.6px"
          : props.varient === "app_ad"
          ? "45px"
          : props.varient === "header_cover"
          ? "78px"
          : "74px"};
      border-radius: 8px;
      height: 100%;
      display: flex;
      width: 100%;
      flex-direction: column;
    }

    .actions {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: ${primayColor};
      border-radius: 8px;
      height: 30px;
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;

      .stories-drowdown-menu {
        max-width: 194px;
        border-radius: 8px;

        .dropdown-item:not(.header) {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: ${white};

          svg {
            margin-right: 0.75rem;
          }

          :hover {
            color: ${accent};
          }
        }

        .artboard-download-item {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: ${white};
          padding: 0.25rem 1.5rem;

          svg {
            margin-right: 0.75rem;
          }

          :hover {
            color: ${accent};
          }
        }

        .title {
          font-weight: 400;
          margin-top: 5px;
          width: 100%;
          color: ${lightInactive};
          font-size: 0.875rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .subtitle {
          font-weight: normal;
          color: ${grey};
          font-size: 0.75rem;
          letter-spacing: 0;
          margin-bottom: 0.25rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        @media (max-width: 768px) {
          width: ${(props) =>
            props.varient === "story"
              ? "108px"
              : props.varient === "cover"
              ? "205px"
              : props.varient === "post"
              ? "151px"
              : props.varient === "ad"
              ? "240px"
              : props.varient === "app_ad"
              ? "45px"
              : props.varient === "header_cover"
              ? "205px"
              : "74px"};

          height: ${(props) =>
            props.varient === "story"
              ? "192px"
              : props.varient === "cover"
              ? "78px"
              : props.varient === "post"
              ? "151px"
              : props.varient === "ad"
              ? "125.6px"
              : props.varient === "app_ad"
              ? "45px"
              : props.varient === "header_cover"
              ? "78px"
              : "74px"};
        }

        .breathing {
          width: 100% !important;
          height: unset !important;
          overflow: hidden;
          box-sizing: border-box;
          display: flex;
          max-height: 100%;
          margin: auto;
          aspect-ratio: ${(props) =>
            props.varient === "story"
              ? "9/16"
              : props.varient === "cover"
              ? "205/78"
              : props.varient === "post"
              ? "1"
              : props.varient === "ad"
              ? "1.91"
              : props.varient === "app_ad"
              ? "1"
              : props.varient === "header_cover"
              ? "2.62"
              : "1"};
        }
      }
    }

    .download-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 8px 8px 0 0;
    }
  }

  .info {
    width: 100%;
    height: 56px;
    background-color: ${greyDark};
    border-radius: 0 0 8px 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;

    .title {
      font-weight: 500;
      margin-top: 5px;
      width: 100%;
      color: ${lightInactive};
      font-size: 0.875rem;
      word-wrap: break-word;
      word-break: break-all;
    }

    .subtitle {
      font-weight: normal;
      color: ${grey};
      font-size: 0.875rem;
      letter-spacing: 0;
      margin-bottom: 0.25rem;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .project {
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      width: 50%;
    }

    .creator {
      display: flex;
      justify-content: center;
      flex-direction: column;
      margin-right: 0.75rem;
    }
  }

  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    border-radius: 8px 8px 0 0;
  }
`;

export const StyledMarketplaceDesignCard = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  height: 100%;
  width: 100%;

  .label-container {
    background-color: #1e1e1e;
    color: #939393;
    display: flex;
    position: absolute;
    right: 0;
    top: 0;
    margin: 16px;
    padding: 8px;
    border-radius: 50%;
    z-index: 100;
    font-size: 14px;
    height: 30px;
    width: 30px;
  }

  .thumbnail {
    height: 261px;
    width: 237px;
    background-color: rgba(255, 255, 255, 0.04);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 3px solid rgba(255, 255, 255, 0.08);
  }

  .artboard-presets {
    border: 0px !important;
  }

  .start-from-scratch-thumbnail {
    width: auto;
    background-color: #232323;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 2px solid #1e1e1e;
    box-sizing: border-box;
    height: 240px;

    transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
      0.3s box-shadow,
      0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
    cursor: pointer;

    .rect-container {
      height: 100%;
      display: flex;
      align-items: center;
      padding-top: 10px;
    }

    .format-footer {
      flex: 1;
      min-width: 0;
    }

    img {
      height: calc(100% - 63px);
      width: auto;
      max-height: calc(100% - 63px);
      max-width: 100%;
      object-fit: contain;
    }

    &.swiper-thumbnail {
      height: auto !important;
      width: unset !important;

      :hover {
        box-shadow: 0px 0px 40px ${onHoverDropShadow};
        -webkit-box-shadow: 0px 0px 40px ${onHoverDropShadow};
        -moz-box-shadow: 0px 0px 40px ${onHoverDropShadow};
      }

      .marketplace-template-format-swiper-image {
        width: 150px;
        max-width: 150px;
        height: 125px;
        max-height: 125px;
        object-fit: contain;

        /* Extra small devices (phones, 600px and below) */
        @media (max-width: 600px) {
          // width: 70px;
          // height: 45px;
        }

        /* Small devices (portrait tablets and large phones, 600px and above) */
        @media (min-width: 600px) {
          width: 120px;
          height: 95px;
        }

        /* Extra large devices (large laptops and desktops, 768px and above) */
        @media (min-width: 768px) {
          width: 150px;
          height: 125px;
        }
      }
    }
  }

  .design-card-thumbnail {
    height: 100%;
    width: 100%;
    position: relative;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
      0.3s box-shadow,
      0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);

    img {
      border-radius: 8px;
      display: block;
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
    img:before {
      content: " ";
      display: block;

      position: absolute;
      top: -10px;
      left: 0;
      height: calc(100% + 10px);
      width: 100%;
      background-color: rgb(230, 230, 230);
      border: 2px dotted rgb(200, 200, 200);
      border-radius: 5px;
    }

    img:after {
      content: "Broken Image of " attr(alt);
      display: block;
      font-size: 16px;
      font-style: normal;
      color: rgb(100, 100, 100);
      position: absolute;
      top: 5px;
      left: 0;
      width: 100%;
      text-align: center;
    }
  }

  .design-card-thumbnail:hover {
    border-radius: 8px;
    box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -webkit-box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -moz-box-shadow: 0px 0px 40px ${onHoverDropShadow};

    img {
      opacity: 0.4;
    }
  }

  .start-from-scratch-thumbnail:hover {
    box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -webkit-box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -moz-box-shadow: 0px 0px 40px ${onHoverDropShadow};
  }

  .divider {
    margin: 10px 0 10px 0;
    height: 1px;
    width: 100%;
    background-color: #494949;
  }

  .title {
    margin-top: 10px;
    font-weight: 500;
    width: 100%;
    color: ${lightInactive};
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .subtitle {
    color: #888888;
    font-family: Rubik;
    font-size: 12px;
    letter-spacing: 0;
  }

  .actions {
    height: 100%;
    background-color: rgba(30, 30, 30, 0.6);
    position: absolute;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: auto;
    top: 0;
    bottom: 0;
    align-items: center;
    justify-content: center;
    color: ${white};

    .action {
      font-weight: 500;
      text-align: center;
      padding: 7px;
      color: ${white};
    }
  }
`;

export const StyledCollection = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(${projectGridItemWidth}, ${projectGridItemWidth})
  );
  grid-gap: 20px;
  grid-auto-rows: minmax(${projectGridItemHeight}, ${projectGridItemHeight});
  color: ${lightInactive};
  justify-content: center;
  height: 100vh;
`;

export const StyledStarterStoryCard = styled(StyledDesignCard)`
  .story-image {
    border: 2px ${primary} dashed;
    background-color: ${greyBlack};
    text-align: center;
    color: ${primary};
    display: flex;
    align-items: center;
  }
`;

export const StyledLoginFormField = styled(Field)`
  background-color: ${greyBlack};
  border: 1px ${greyBlack} solid !important;
  color: ${lightInactive};
  height: 40px;
  flex-grow: 1;
  border-radius: 8px;
  padding-left: 1rem;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;

  &::placeholder {
    color: ${placeholderColor};
    font-size: 1rem;
    letter-spacing: 0.08px;
    line-height: 28px;
  }

  &:-ms-input-placeholder {
    color: ${placeholderColor};
    font-size: 1rem;
    letter-spacing: 0.08px;
    line-height: 28px;
  }

  &::-ms-input-placeholder {
    color: ${placeholderColor};
    font-size: 1rem;
    letter-spacing: 0.08px;
    line-height: 28px;
  }

  .input {
    background-color: transparent !important;
    color: ${lightInactive} !important;
    font-size: 1rem !important;
    letter-spacing: 0.08px !important;
    line-height: 28px !important;
    outline: none;
    padding-left: 1rem;
  }

  :focus {
    color: ${lightInactive};
    background-color: ${greyBlack} !important;
  }
  :hover {
    border: 1px ${primary} solid !important;
  }
`;

export const StyledContentOverlay = styled.div`
  background-color: transparent;
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  transition: all 0.4s ease-in-out 0s;
  border-radius: 6px;
  -webkit-user-drag: none;

  ${(props) =>
    props.isDragging &&
    `
    opacity: 0 !important;
    `};
`;

export const StyledContentDetails = styled.div`
  position: absolute;
  text-align: center;
  width: fit-content;
  height: fit-content;
  opacity: 1;
  transition: all 0.3s ease-in-out 0s;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  -webkit-user-drag: none;
  top: 10px;
  right: 10px;
  background-color: ${primayColor};
  border-radius: 8px;
  min-height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  .fa-ellipsis-v {
    path {
      fill: ${lightInactive};
    }
  }

  .actions {
    z-index: 100;
    padding-left: -1em;
    padding-right: -1em;
    height: 50px;
    background-color: rgba(255, 172, 65, 0.9);
    position: absolute;
    border-radius: 8px 8px 0 0;
    display: flex;
    width: 100%;
    bottom: 0;
    align-items: center;
    justify-content: space-around;

    .action {
      font-weight: 500;
      text-align: center;
      padding: 7px;
      color: ${black};
    }
  }

  .dropdown-item {
    color: ${white};
  }
`;

export const StyledContentSourceInfo = styled(StyledContentDetails)`
  top: unset;
  left: 0;
  right: 0 !important;
  bottom: 0 !important;
  display: none;
  width: 100%;

  p {
    color: ${lightInactive};
    font-size: 0.75rem;
    margin-bottom: 2px !important;

    a {
      color: ${accent};
      font-size: inherit;
    }
  }
`;

export const StyledSidebarAside = styled.aside`
  width: ${sideBarWidth} !important;
  height: calc(100vh - ${headerHeight}) !important;
  -webkit-box-shadow: 8px 0 16px 0 ${onHoverDropShadow};
  -moz-box-shadow: 8px 0 16px 0 rgba(184, 154, 154, 0.5);
  box-shadow: 8px 0 16px 0 ${onHoverDropShadow};
  background-color: ${secondaryColor};
  z-index: 499;
  position: fixed;
  overflow-y: scroll;
  overflow-y: overlay;
  // margin-top: ${headerHeight};
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &::-webkit-scrollbar {
    display: none;
  }
`;

StyledSidebarAside.methodName = "TLDRMainSidebar";

export const StyledNavbarUserInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .picture {
    color: ${primary};
    border: ${(props) =>
      props.selected
        ? `2px solid ${primaryHover}`
        : `2px solid ${props.bgColor}`};
    border-radius: 50%;

    &.medium-size {
      width: 32px;
      height: 32px;
      overflow: hidden;

      svg {
        height: 30px;
        width: 30px;
      }
    }

    img {
      border-radius: 50%;
      object-fit: cover;
      width: 100%;
      height: 100%;
    }

    svg {
      align-self: center;
      justify-content: center;
    }

    :hover {
      border: 2px solid ${primaryHover};
      cursor: pointer;
    }
  }

  .fa-angle-down,
  .fa-angle-up {
    path {
      fill: ${lightInactive};
    }
  }

  .user {
    margin-right: 0;
    padding-left: 0;
    text-overflow: ellipsis;

    @media (max-width: 768px) {
      padding-left: 0px;
      overflow: hidden;
    }

    .email,
    .subscription {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      font-size: 12px;
      letter-spacing: 0;
      color: ${lightInactive};
    }

    .email.navbar-header-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 155px;
    }

    .company {
      color: ${lightInactive};
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      line-height: 14px;
      margin-top: 4px;
      white-space: nowrap;
      font-weight: 500;
    }

    .subscription {
      ${(props) => `color: ${props.subscriptionColor}`};
    }
  }

  .pro-icon {
    background-color: #1e1e1e;
    border-radius: 50%;
    margin-right: 10px;
    font-size: 14px;
    width: 35px;
    min-width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
  }

  .organization-initials {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    font-weight: bold;
    color: ${lightInactive};
    width: 35px;
    min-width: 35px;
    height: 35px;
    border-radius: 50%;
    ${(props) => `border: 2px ${props.subscriptionColor} solid`};
  }
`;

export const StyledNavbarUserInfoHeader = styled(StyledNavbarUserInfo)`
  @media (max-width: 768px) {
    margin-left: 20px;
    margin-right: 0;
    padding: 12px 0px;
  }
`;

export const StyledCreatorInfo = styled(StyledNavbarUserInfo)`
  justify-content: flex-end;
`;

export const StyledRnd = styled(Rnd)`
  display: flex !important;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0);
  position: relative !important;
  border: 3px solid ${primary};
  border-radius: 8px;
`;

export const StyledVideoDurationContainer = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 2px 6px;
  color: ${lightInactive};
  background: rgba(0, 0, 0, 0.6);
  border-radius: 8px;
  font-size: 12px;
`;

export const StyledShareWeb = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0;

  .control {
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .info {
    flex: 1;
    .title {
      font-weight: 500;
      width: 100%;
      color: ${lightInactive};
      font-size: 1rem;
      word-wrap: break-word;
      word-break: break-all;
    }

    .subtitle {
      font-weight: 400;
      color: #888888;
      font-size: 0.875rem;
      letter-spacing: 0;
    }
  }

  .toggle {
    align-self: center;
  }
`;

export const StyledCommandKTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 7px;

  .tooltip-title {
    color: ${lightInactive};
    font-size: 14px;
    text-align: center;
    margin-bottom: 0.5rem;
  }

  .tooltip-subtitle {
    color: ${grey};
    text-align: center;
    margin-bottom: 0.5rem;
  }

  .hotkeys {
    font-size: 18px;

    svg {
      display: unset;
    }
  }
`;

export const StyledKeyboardShortcutsCategories = styled.div`
  color: ${lightInactive};
  font-weight: bold;

  .kbd-shortcuts-panel-hr {
    margin-top: 0.3rem !important;
    border-color: ${lightInactive} !important;
    opacity: 0.5;
    margin-bottom: 1rem;
  }
`;

export const StyledKeyboardShortcutsSubcategories = styled.div`
  color: ${lightInactive};
  font-weight: normal;
  font-size: 14px;

  .keyboard-shortcuts,
  .keyboard-shortcuts-keys {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    p {
      margin-bottom: 0 !important;
      margin-left: 0.25rem;
    }
  }

  .kbd-shortcuts-panel-hr {
    margin-top: 0.3rem !important;
    border-color: ${lightInactive} !important;
    opacity: 0.2;
  }

  kbd {
    margin-left: 0.25rem;
  }
`;

export const StyledStoryNameSubLabel = styled.label`
  color: #888888;
  border-radius: 8px;
  font-size: 12px;
  //margin: 0rem 0.5rem;
  //padding: 5px 2px;
  outline: none;
  box-shadow: none !important;
  height: 14px;
  line-height: 14px;
  padding-left: 5px;
  padding-top: 2px;

  @media (max-width: ${md}) {
    margin-bottom: 0px;
  }
`;

export const StyledStoryNameInput = styled.div`
  color: ${lightInactive};
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  box-shadow: none !important;
  height: 19px;
  width: 150px;
  line-height: 17px;
  padding-left: 5px;
  padding-top: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  :hover {
    cursor: pointer;
  }

  .previewTitle {
    font-size: 24px;
    width: unset;
    display: flex;
    justify-content: center;
  }

  .icon {
    height: 16px;
    width: 16px;
  }

  @media (max-width: ${md}) {
    font-size: 18px;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: auto;
  }
`;

export const StyledPreviewStoryName = styled.div`
  font-size: 18px;
  font-family: Rubik;
  font-weight: 500;
  width: 400px;
  display: flex;
  color: ${lightInactive};
  outline: none;
  box-shadow: none !important;
  height: 22px;
  line-height: 22px;
  margin-top: 5px;
  justify-content: center;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const StyledSaveAsTemplateTextBlock = styled.div`
  display: block;
  margin-bottom: 15px;
  font-size: 15px;
`;

export const StyledStoryNameSubBlock = styled.div`
  height: 40px;
  margin-top: 20px;
  margin-bottom: 19px;
  width: 200px;

  @media (max-width: ${md}) {
    width: auto;
  }
`;

export const StyledCategories = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const StyledAICategories = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  margin-bottom: 0px;
  color: #d8d8d8;
  width: auto;

  @media (max-width: 768px) {
    flex-wrap: nowrap;
    padding-left: 0px;
    padding-right: 0px;
    width: max-content;
  }
`;

export const StyledUserOrgsContainer = styled.div`
  max-height: 320px;
  overflow-y: ${(props) => (props.overflowY ? props.overflowY : "auto")};

  .dropdown-divider {
    height: 0;
    margin: 0.5rem 0;
    overflow: hidden;
    border-top: 1px solid rgb(30, 30, 30);
  }
`;

export const StyledTldrLabel = styled.div`
  height: 14px;
  color: ${lightInactive};
  font-family: Rubik;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 14px;
  text-transform: uppercase;
`;

export const StyledVideoLink = styled.div`
  .view-in-action-link {
    color: ${accent};
  }
`;

export const StyledSidebarFooter = styled.div`
  .divider {
    margin-bottom: 12px !important;
    margin-top: 12px !important;
  }
  .container {
    display: flex;
    flex-direction: column;
  }
  .container:hover {
    color: ${primaryHover};
  }
  .icon-wrapper {
    height: 35px;
    width: 35px;
    background-color: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
    align-self: center;
    align-items: center;
    justify-content: center;
    display: flex;
  }
  .active {
    color: ${primary_00};
  }
  .label {
    padding-top: 10px;
  }
  .label:hover {
    color: ${primaryHover};
  }
`;

export const StyledDrawer = styled.div`
  position: absolute;

  .drawer {
    background-color: ${greyDark} !important;
    height: fit-content;
  }

  .drawer__backdrop {
    display: none:
  }

  .drawer__handle-wrapper {
    background-color: ${greyDark};
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .drawer__handle {
  }

  .drawer__content {
    background-color: ${greyDark};
    max-height: unset !important;
  }
`;

export const StyledArtboardBottomDrawer = styled.div`
  height: fit-content;
  width: 100%;

  .drawer {
    background-color: ${greyDark} !important;
    height: fit-content;
    z-index: 1;
  }

  .drawer__backdrop {
    display: none;
  }

  .drawer__handle-wrapper {
    background-color: ${lightBlackAlpha16};
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 0px;
    padding-left: 88px;

    @media (max-width: 768px) {
      padding-left: 0px;
    }
  }

  .drawer__handle {
    width: 10px !important;
  }

  .handle {
    font-size: 0.75rem;
    color: ${lightInactive};
    cursor: grab;
  }

  .drawer__content {
    background-color: ${greyDark};
    max-height: unset !important;
    padding: 0px;
  }
`;

export const StyledAdvancedDrawer = styled.div`
  .drawer {
    background-color: ${greyDark} !important;
    // height: 35%;
    display: flex;
    flex-direction: column;
  }

  .drawer__backdrop {
    display: none;
  }

  .drawer__handle-wrapper {
    background-color: ${greyDark};
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .drawer__handle {
  }

  .drawer__content {
    height: 100%;
    background-color: ${greyDark};
    padding: 0px;
    max-height: unset;
  }
`;

export const StyledFullDrawer = styled.div`
  position: absolute;

  .drawer {
    background-color: ${greyDark} !important;
    // height: calc(100% - 122px);
    display: flex;
    flex-direction: column;
    bottom: 61px;
    z-index: 11;
  }

  .drawer__backdrop {
    display: none;
    height: 100%;
  }

  .drawer__handle-wrapper {
    background-color: ${greyDark};
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .drawer__handle {
  }

  .drawer__content {
    height: 100%;
    background-color: ${greyDark};
    max-height: unset !important;
    padding: 0px;
    flex-grow: 1;
  }
`;

export const StyledCustomHeightDrawer = styled.div`
  position: absolute;

  .drawer {
    background-color: ${greyDark} !important;
    // height: calc(100% - 122px);
    display: flex;
    flex-direction: column;
    bottom: 61px;
    z-index: 11;
    max-height: 495px;
    border-radius: 8px 8px 0px 0px;
  }

  .drawer__backdrop {
    display: none;
    height: 100%;
  }

  .drawer__handle-wrapper {
    background-color: ${greyDark};
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .drawer__handle {
  }

  .drawer__content {
    background-color: ${greyDark};
    max-height: unset !important;
    padding: 0px;
    flex-grow: 1;
  }
`;

export const BottomDrawerDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${grey};
`;

export const TabbarWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${greyDark};
  overflow: hidden;

  .cross-btn-container {
    height: 60px;
    width: 60px;
    min-width: 60px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: ${greyDark};
  }

  .cross-btn {
    height: 32px;
    width: 32px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: ${lightInactive};
    border-radius: 16px;
  }
`;

export const StyledHorizontalDivider = styled.div`
  width: 100%;
  border: 1px solid #494949;
  &:last-child {
    display: none;
  }
`;

export const StyledMemberIdentified = styled.div`
  color: ${lightInactive};
  // display: flex;
  // align-items: center;
  // width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-direction: row;
`;

export const StyledMemberWRole = styled.div`
  color: ${grey};
  font-weight: 400;
  font-size: 0.875rem;
`;

export const StyledMemberWRoleSpan = styled.span`
  color: ${grey};
  font-weight: 400;
  font-size: 0.875rem;
`;

export const StyledWorkspaceName = styled.span`
  color: ${accent};
`;

export const StyledMembersWrapper = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;
